'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
require('./Toggle.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * A toggle switch.
 */
var Toggle = function Toggle(_ref) {
  var checked = _ref.checked,
    disabled = _ref.disabled,
    value = _ref.value,
    name = _ref.name,
    onChange = _ref.onChange;
  return _react2.default.createElement('div', {
    className: 'c-toggle'
  }, _react2.default.createElement('input', {
    type: 'checkbox',
    defaultChecked: checked,
    disabled: disabled,
    value: value,
    name: name,
    onChange: onChange
  }), _react2.default.createElement('div', {
    className: 'c-toggle__back'
  }), _react2.default.createElement('div', {
    className: 'c-toggle__knob'
  }));
};
Toggle.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Indicates if the toggle is checked */
  checked: _propTypes2.default.bool,
  /** Indicates if the toggle is disabled */
  disabled: _propTypes2.default.bool,
  /** The value of the toggle switch */
  value: _propTypes2.default.string,
  /** The name attribute, containing a name that identifies the element when submitting the form */
  name: _propTypes2.default.string,
  /** Callback function that is fired when the toggle switch is toggled */
  onChange: _propTypes2.default.func
} : {};
Toggle.defaultProps = {
  checked: false,
  disabled: false
};
exports.default = Toggle;